module.exports = __webpack_public_path__ + "img/33.3bc7ff30.jpeg";